export default "__VITE_ASSET__0f19eba7__"